export default __webpack_public_path__ + "static/media/3x3.e26ea7a2.svg";